import { mutationFetcher } from "../utils/default-fetcher";
import { useHook, useMutationHook } from "../utils/use-hook";
export const fetcher = mutationFetcher;
const fn = (provider)=>{
    var ref;
    return (ref = provider.customer) == null ? void 0 : ref.useUpdateCustomer;
};
const useUpdateCustomer = (...args)=>{
    const hook = useHook(fn);
    return useMutationHook({
        fetcher,
        ...hook
    })(...args);
};
export default useUpdateCustomer;
